var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error merror error-pill d-flex justify-content-start align-items-center"},[_vm._v(" "+_vm._s(_vm.$t(`errors.${_vm.message}`))+" ")]),_c('audio',{ref:"audio",staticClass:"d-none",attrs:{"autoplay":"false","controls":""}},[_c('source',{attrs:{"src":"/audio/error.mp3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }